var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page)?_c('Page',{staticClass:"page",attrs:{"page":_vm.page}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }